import React from "react";
import { connect } from "react-redux";
import { Preloader } from "lantmannen-common-widget";

const ConnectedPreloader = ({ loading, ...props }) => {
  return loading ? <Preloader fixed size="large" /> : null;
};

const mapStateToProps = state => ({
  loading: state.ui.loading
});

export default connect(mapStateToProps)(ConnectedPreloader);
